/**
 *
 * FreeModeBook
 *
 */

import _ from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import $ from 'jquery';
import Swal from 'sweetalert2';
import VueScrollTo from 'vue-scrollto';

import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
// import LivePlayer from '@/components/LivePlayer.vue';
import ButtonBookAllFile from '@/components/ButtonBookAllFile.vue';
import { ClassChineseFrmMixin } from '@/mixins/ClassChineseFrm';
import { getDurationString } from '../../../utils';

export default {
  name: 'FreeModeBook',

  mixins: [ClassChineseFrmMixin],

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    Player,
    // LivePlayer,
    ButtonBookAllFile,
  },

  data: () => {
    return {
      isShowPlayer: false,
      isShowLivePlayer: false,
      currentVideo: {},
      generating: false,

      promiseFetchBook: null,
      hideCurrentBtn: false,
    };
  },

  computed: {
    ...mapState({
      ms_isSetGotoLastStudy: 'isSetGotoLastStudy',
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      Book: 'FreeModeBook/Book',
      immLoading: 'immLoading',
      isRequest: 'FreeModeBook/isRequest',
      ReadyToPlayVideos: 'FreeModeBook/ReadyToPlayVideos',
      lastTimeReadingBulletId: 'FreeModeBook/lastTimeReadingBulletId',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    BookId: function () {
      return this.$route.params.bookId;
    },

    c_isCpaCourse: function () {
      return 'cpa' === this.Book.mallCategory;
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    this._FreeModeBookMounted();
  },

  created() {
    this.promiseFetchBook = this.getBook(this.BookId);
  },

  methods: {
    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    ...mapActions({
      getBook: 'FreeModeBook/getBook',
      addToFavoriteList: 'FreeModeBook/addToFavoriteList',
      generateFile: 'FreeModeBook/generateFile',
    }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find((v) => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    openLivePlayer(bullet) {
      window.open(`${bullet.liveURL}`, '_blank');
    },

    // closeLivePlayer() {
    //   this.isShowLivePlayer = false;
    // },

    goToNextVideo() {
      const index = _.findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    goBack() {
      this.$router.go(-1);
    },

    async generatePDF(file) {
      this.generating = true;
      await this.generateFile({
        courseId: this.CourseId,
        bookId: this.BookId,
        fileId: file.fileId,
      });
      this.generating = false;
    },

    async markVideo(payload) {
      await this.addToFavoriteList(payload);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.currentVideo.collected ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    changeBulletStatus(video, status) {
      this.$store.commit('FreeModeBook/SET_BULLET_STATUS', { video, status });
    },

    getDurationStringText(second) {
      return getDurationString(second);
    },

    scrollToReading(readingId) {
      const context = this;
      setTimeout(() => {
        context.currentReadingId = readingId;
        setTimeout(() => {
          context.currentReadingId = '';
        }, 1000);
      }, 600);

      VueScrollTo.scrollTo(`#reading-id-${readingId}`, 500, {
        container: '.webapp-layout-main',
        easing: 'linear',
        offset: -150,
      });
    },

    openLastTimeBullet() {
      if (
        -1 !== this.lastTimeReadingBulletId.readingId &&
        -1 !== this.lastTimeReadingBulletId.bulletId
      ) {
        this.$nextTick(() => {
          const btnOpenPlayer = _.find(
            this.$refs.btnsOpenPlayer,
            (btnOpenPlayer) =>
              `bullet-${this.lastTimeReadingBulletId.bulletId}` === btnOpenPlayer.id
          );
          if (btnOpenPlayer) {
            btnOpenPlayer.click();
          }
        });
      }
    },

    gotoLastTimeReading() {
      this.hideCurrentBtn = true;
      this.scrollToReading(this.lastTimeReadingBulletId.readingId);
      setTimeout(() => {
        this.openLastTimeBullet();
      }, 500);
    },

    async _FreeModeBookMounted() {
      await this.promiseFetchBook;
      await this.$nextTick();
      $('[data-toggle="popover"]').popover();
      setTimeout(() => {
        this.hideCurrentBtn = true;
      }, 15000);
      if (this.ms_isSetGotoLastStudy) {
        this.mm_SET_GOTO_LAST_STUDY(false);
        this.hideCurrentBtn = true;
        if (!this.$route.params.readingId && -1 !== this.lastTimeReadingBulletId.readingId) {
          this.scrollToReading(this.lastTimeReadingBulletId.readingId);
        }
        setTimeout(() => {
          this.openLastTimeBullet();
        }, 500);
      }
    },
  },
};
